import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const UseHotels = () => {

  
  const cardRef = useRef(null)
  const navigate = useNavigate()
  const [openHotelSearch, setOpenHotelSearch] = useState(false)
  const [paceholders, setPaceholders] = useState('')
  const [search, setSearch] = useState('')
  const [destiny, setDestiny] = useState([])
  const [destinitySelected, setDestinitySelected] = useState('')
  const [nacionalityDropdown, setNacionalityDropdown] = useState(false)
  const [dataNacionality, setDataNacionality] = useState([])
  const [dateEntry, setDateEntry] = useState(false)
  const [nacionality, setNacionality] = useState('')
  const [loading, setLoading] = useState(false)
 
  const [loadingSearch, setLoadingSearch] = useState(false)
  const [codeNacionality, setCodeNacionality] = useState('')
  const [allDataCodeCobol, setAllDataCodeCobol] = useState([])
  const [onlyCodeCobol, setOnlyCodeCobol] = useState([])
  const [datesSelected, setDatesSelected] = useState({
    entryDate: 'Entrada',
    exitDate: 'Salida'
  })

  let quantity = 0

  const [cardRooms, setCardRooms] = useState(false)
  const [roomsSelected, setRoomsSelected] = useState([
    {
      adult: 1,
      child: 0,
      age: []
    }
  ])

  const [quantityPersons, setQuantityPersons] = useState(1)

  useEffect(() => {
    let contador = 0
    for (let index = 0; index < roomsSelected.length; index++) {
      contador += roomsSelected[index].adult + roomsSelected[index].child
    }
    setQuantityPersons(contador)
  }, [roomsSelected])


  const openHotelSearchFuct = () => {
    setOpenHotelSearch(!openHotelSearch)
  }

  const destinationSelectionFunc = (element) => {
    setPaceholders(element.name)
    setDestinitySelected(element.code)
    setOpenHotelSearch(false)
  }

  const findCountryClient = (country) => {
    setLoading(true)
    axios.post('https://travelflight.pdtcomunicaciones.com/api/restel/country', {
      'code': country
    })
      .then(res => {
        setDataNacionality(res.data)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }

  const selectedNacionality = (code, name) => {
    setNacionality(name)
    setCodeNacionality(code)
  }

  function generateUniqueId() {
    return 'xxxxx-xxxx-4xxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  const searchHotelSelected = () => {
    setLoadingSearch(true)
    axios.post("https://travelflight.pdtcomunicaciones.com/api/restel/disponibility", {
      "arrival": `${datesSelected.entryDate}`,
      "departure": `${datesSelected.exitDate}`,
      "country": "CO",
      "countryClient": codeNacionality,
      "hotels": onlyCodeCobol,
      "rooms": roomsSelected
    })
      .then(res => {
        setLoadingSearch(false)
        console.log(res.data)
        navigate(`/hotels/${generateUniqueId()}`, {
          state: {
            data: res.data
          }
        })

      })
      .catch(err => {
        console.log(err)
        setLoadingSearch(false)
      })

  }

  useEffect(() => {
    const getResults = async () => {
      const result = await axios.post('https://travelflight.pdtcomunicaciones.com/api/restel/cities', {
        "code": `${search}`
      })
      setDestiny(result.data)

    }
    getResults()
  }, [search])

  useEffect(() => {
    axios.post('https://travelflight.pdtcomunicaciones.com/api/restel/hotels', {
      "city": paceholders
    })
      .then(res => {
        setAllDataCodeCobol(res.data[0])
      })
      .catch(err => {
        console.log(err)
      })


  }, [paceholders])


  function obtenerCodeCOBOL(arr) {
    let codeCOBOLArray = [];

    for (let i = 0; i < arr.length; i++) {
      let obj = arr[i];
      let codeObj = { "code": obj.code_cobol };
      codeCOBOLArray.push(codeObj);
    }

    setOnlyCodeCobol(codeCOBOLArray)

  }



  useEffect(() => {

    obtenerCodeCOBOL(allDataCodeCobol)


  }, [allDataCodeCobol])



  useEffect(() => {
    const handler = (e) => {
      if (!cardRef?.current?.contains(e.target)) {
        setOpenHotelSearch(false)
        setDateEntry(false)
        setCardRooms(false)
      }
    }
    document.addEventListener('mousedown', handler)
    return () => {
      document.removeEventListener('mousedown', handler)
    }
  }, [])

 





  return {
    cardRef,
    openHotelSearch,
    setOpenHotelSearch,
    paceholders,
    setPaceholders,
    search,
    setSearch,
    destiny,
    setDestiny,
    destinitySelected,
    setDestinitySelected,
    dateEntry,
    setDateEntry,
    datesSelected,
    setDatesSelected,
    quantity,
    cardRooms,
    setCardRooms,
    roomsSelected,
    setRoomsSelected,
    quantityPersons,
    setQuantityPersons,
    openHotelSearchFuct,
    destinationSelectionFunc,
    searchHotelSelected,
    findCountryClient,
    nacionalityDropdown,
    setNacionalityDropdown,
    dataNacionality,
    selectedNacionality,
    nacionality,
    codeNacionality,
    loading,
    loadingSearch
  }
}

export default UseHotels